import LegalEntityForm from './LegalEntityForm';
import IndividualForm from './IndividualForm';
import GroupForm from './GroupForm';
import BasicForm from './BasicForm';

const forms = () => {

	const legalEntity = document.getElementById('legal-entity-application-form');
	const individual = document.getElementById('individual-application-form');
	const group = document.getElementById('group-application-form');
	const basic = document.getElementById('basic-application-form');

	if (legalEntity) {
		new LegalEntityForm(legalEntity);
	}

	if (individual) {
		new IndividualForm(individual);
	}

	if (group) {
		new GroupForm(group);
	}

	if (basic) {
		new BasicForm(basic);
	}

}

export default forms;
